"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpRubricAnalysis = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var DpSectionCard_1 = require("../../Cards/DpSectionCard");
var chartTypes_enum_1 = require("../../Charts/chartTypes.enum");
var scoring_type_enum_1 = require("../../../../api/constants/scoring-type.enum");
var rubric_variations_enum_1 = require("../../../../api/constants/rubric-variations.enum");
var variation_criterias_helper_1 = require("../../../../api/helpers/variation-criterias.helper");
var DpItemAnalysisChart_1 = require("../../ItemAnalysisChart/DpItemAnalysisChart");
var DpRubricAnalysisHeader_1 = __importDefault(require("./DpRubricAnalysisHeader"));
var DpRubricAnalysis_styled_1 = require("./DpRubricAnalysis.styled");
var DpViewRubricModal_1 = __importDefault(require("../ViewRubricModal/DpViewRubricModal"));
var GlobalNav_1 = require("../../../GlobalNav");
var DpRubricAnalysis = function (_a) {
    var identifier = _a.identifier, assessment = _a.assessment, type = _a.type, overallRubricPerformance = _a.overallRubricPerformance, openItemAnalysisModal = _a.openItemAnalysisModal;
    // ----------- State
    var _b = (0, react_1.useState)(false), initialized = _b[0], setInitialized = _b[1];
    var _c = (0, react_1.useState)(false), showModal = _c[0], setShowModal = _c[1];
    var _d = (0, react_1.useState)([]), formattedData = _d[0], setFormattedData = _d[1];
    // ----------- Events
    var openModal = function () { return setShowModal(true); };
    var closeModal = function () { return setShowModal(false); };
    // ----------- Const
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var assessmentTemplate = assessment.assessmentTemplate;
    var globalNav = (0, GlobalNav_1.useGlobalNavV2)();
    var header = ((0, jsx_runtime_1.jsx)(DpRubricAnalysisHeader_1.default, { openModalHandler: openModal, type: type, openItemAnalysisHandler: openItemAnalysisModal, itemExternalId: assessment.assessmentTemplate.items[identifier].externalId, itemExternalBankItemId: assessment.assessmentTemplate.items[identifier].externalBankItemId, identifier: identifier }));
    var variation = (0, rubric_variations_enum_1.getVariationsFrom)(assessment.assessmentTemplate.items[identifier].variation);
    var customOptions = {
        maintainAspectRatio: false,
        scales: {
            xAxes: [
                {
                    ticks: {
                        callback: function (value) { return value; },
                    },
                },
            ],
        },
    };
    // ----------- Methods
    var parseReportData = (0, react_1.useCallback)(function (criteriaPerformance) { return __awaiter(void 0, void 0, void 0, function () {
        var reportData;
        return __generator(this, function (_a) {
            if (!(0, isEmpty_1.default)(criteriaPerformance)) {
                reportData = criteriaPerformance.map(function (item) {
                    var label = type === scoring_type_enum_1.ScoringType.Matrix
                        ? assessmentTemplate.isVocabularyAssignment
                            ? t("rubricAnalysis.matrix.word", {
                                value: item.key,
                            })
                            : t("rubricAnalysis.matrix.criterion", {
                                value: item.key,
                            })
                        : (0, variation_criterias_helper_1.variationCriterias)(variation)["_".concat(item.key)];
                    return {
                        label: label,
                        percentage: item.percentage,
                    };
                });
                setFormattedData(reportData);
                setInitialized(true);
            }
            return [2 /*return*/];
        });
    }); }, [t, type, variation, assessmentTemplate]);
    (0, react_1.useEffect)(function () {
        if (!(0, isEmpty_1.default)(overallRubricPerformance)) {
            parseReportData(overallRubricPerformance.rubricCriteriaPerformances);
        }
    }, [overallRubricPerformance, parseReportData]);
    var goToPrintPage = function () {
        var _a;
        var rubricReference = assessmentTemplate.items[identifier].questions.find(function (question) { return question.rubricReference; }).rubricReference;
        window.open("".concat(window.location.origin, "/assessments/teacher/library/assessment/rubric/printable?rubricReference=").concat(rubricReference, "&type=").concat(assessmentTemplate.items[identifier].scoringType, "&title=").concat(assessmentTemplate.title, "&curriculumId=").concat((_a = globalNav === null || globalNav === void 0 ? void 0 : globalNav.selected) === null || _a === void 0 ? void 0 : _a.id, "&fullScreen=1"), '_blank');
    };
    // ----------- Render
    return (initialized && ((0, jsx_runtime_1.jsxs)(DpRubricAnalysis_styled_1.StyledRubricAnalysis, { "data-testid": "rubric-analysis", children: [(0, jsx_runtime_1.jsx)(DpSectionCard_1.DpSectionCard, { title: header, children: (0, jsx_runtime_1.jsx)("div", { className: "report", children: (0, jsx_runtime_1.jsx)(DpItemAnalysisChart_1.DpItemAnalysisChart, { id: "rubricAnalysis_".concat(assessment.id, "_").concat(identifier + 1), type: chartTypes_enum_1.LibraryChartTypes.Bar, options: customOptions, items: formattedData, ariaLabel: t("rubricAnalysis.ariaLabel.rubricAnalysisLabel", {
                            title: assessment.assessmentTemplate.title,
                        }) }) }) }), showModal && ((0, jsx_runtime_1.jsx)(DpViewRubricModal_1.default, { identifier: identifier, show: showModal, assessmentTemplate: assessmentTemplate, isEnableWWAssessmentDecorator: true, type: type, closeHandler: closeModal, printHandler: function () { return goToPrintPage(); } }))] })));
};
exports.DpRubricAnalysis = DpRubricAnalysis;
exports.default = exports.DpRubricAnalysis;
